import { COLORS } from "../../data/catalog";

export const Swatches = ({ value, onChange, prefix, size = "md", showLabel = false }) => {
  const dim = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-4 w-4" : "h-8 w-8";
  return (
    <div className="flex flex-wrap items-center gap-3" role="radiogroup" aria-label="Color">
      {COLORS.map((c) => (
        <button
          key={c.id}
          role="radio"
          aria-checked={value === c.id}
          aria-label={c.name}
          title={c.name}
          data-testid={`${prefix}-swatch-${c.id}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange(c.id); }}
          onMouseEnter={size === "sm" ? () => onChange(c.id) : undefined}
          className={`group relative rounded-full p-[3px] ring-1 transition-[box-shadow,transform] duration-300 hover:scale-105 ${value === c.id ? "ring-ink" : "ring-transparent"}`}
        >
          <span className={`block rounded-full ${dim} shadow-[inset_0_0_0_1px_rgba(0,0,0,0.12)]`} style={{ background: c.hex }} />
          {showLabel && <span className="mt-2 block text-center text-[11px] text-graphite">{c.name}</span>}
        </button>
      ))}
    </div>
  );
};
